import React, { useState } from 'react';
import "./OrderHistory.css";
import "./../LoyalitySchemeAccordion.css";

const OrderHistory = ({ orderDetails }) => {
    console.log("axax", orderDetails);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const filteredOrders = orderDetails.filter(order =>
        order.restaurantName.toLowerCase().includes(search.toLowerCase()) ||
        order.orderId.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
    const currentOrders = filteredOrders.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePrev = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNext = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    return (
      <div className="oh-section">
        <div className="oh-section-header">
          <h2 className="loyalty-title">Order History</h2>
          <input
            type="text"
            placeholder="Search by order ID or restaurant name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="loyalty-search-input"
          />
        </div>
        <div className="oh-table">
          <div className="oh-table-header">
            <span className="oh-th-order-id">Order ID</span>
            <span className="oh-th-restaurant">Restaurant</span>
            <span className="oh-th-points">Points Earned</span>
            <span className="oh-th-amount">Total Amount</span>
            <span className="oh-th-date">Date</span>
          </div>
          <div className="oh-table-body">
            {currentOrders.length > 0 ? (
              currentOrders.map((order, index) => (
                <div className="oh-row" key={index}>
                  <div className="oh-cell oh-order-id">
                    <span className="oh-order-value">{order.orderId}</span>
                  </div>
                  <div className="oh-cell oh-restaurant">
                    <span className="oh-restaurant-name">
                      {order.restaurantName}
                    </span>
                  </div>
                  <div className="oh-cell oh-points">
                    <span className="oh-points-value">+{order.points}</span>
                  </div>
                  <div className="oh-cell oh-amount">
                    <span className="oh-amount-value">
                      £{order.totalAmount}
                    </span>
                  </div>
                  <div className="oh-cell oh-date">
                    <span className="oh-date-value">
                      {/* {new Date(order.creationDate).toLocaleDateString()} */}
                      {new Date(order.creationDate).toLocaleString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                        //   hour: "2-digit",
                        //   minute: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="oh-no-data">
                {search
                  ? "No orders found matching your search."
                  : "No orders found."}
              </div>
            )}
          </div>
        </div>
        {filteredOrders.length > 0 && (
          <div className="pagination">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        )}
      </div>
    );
};

export default OrderHistory;